export default {
	RESERVATIONS: 'companies/:company_id/reservations/',
	// APPLICATION_REJECT: 'applications/reject/',
	// APPLICATION_ADD_TO_LEASE: 'applications/add-to-lease/',
	// APPLICATION_CONFIG_IMPORT: 'applications/import-config/'
}
